import { render, staticRenderFns } from "./DeletePageItem.vue?vue&type=template&id=32a80916&"
import script from "./DeletePageItem.vue?vue&type=script&lang=js&"
export * from "./DeletePageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports